import {TweenMax, Circ, Power4} from 'gsap';

export class SidebarFilter {
    private readonly btns: NodeList = document.querySelectorAll<HTMLElement>(".js-sidebar-btn");
    private readonly sidebar: HTMLElement = <HTMLElement>document.querySelector(".js-insight-sidebar");
    private readonly overlay: HTMLElement = <HTMLElement>document.querySelector(".js-insight-overlay");
    private readonly body: HTMLElement = <HTMLElement>document.querySelector("body");
    private isOpened: boolean = false;

    constructor() {
        if (this.btns.length > 0) {
            this.init();
        }
    }

    private init(): void {
        // @ts-ignore
        for (let btn of this.btns) {
            btn.addEventListener('click', (ev: any) => {
                ev.preventDefault();

                if (this.isOpened) {
                    this.close();
                } else {
                    this.open();
                }
            });
        }
    }

    private close(): void {
        this.isOpened = false;
        this.body.classList.remove('is-locked');

        TweenMax.to(this.sidebar, 0.4, {
            x: '-100%',
            ease: Circ.easeOut
        });

        TweenMax.to(this.overlay, 0.3, {
            autoAlpha: 0,
            ease: Circ.easeOut
        });
    }

    private open(): void {
        this.isOpened = true;
        this.body.classList.add('is-locked');

        TweenMax.to(this.sidebar, 0.7, {
            x: '0%',
            ease: Power4.easeOut
        });

        TweenMax.to(this.overlay, 0.3, {
            autoAlpha: 0.55,
            ease: Circ.easeOut
        });
    }
}
